import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { useProviderSearchStore } from "../store/providerSearchStore";

import AddressSearchField from "./Fields/AddressSearchField";
import CustomAddressSearchBar from "./Fields/CustomAddressSearchBar";
import DrawerFilterBtn from "./Fields/DrawerFilterBtn";
import ProviderNameSearchField from "./Fields/ProviderNameSearchField";
import ProviderTypeSearchField from "./Fields/ProviderTypeSearchField";

export default function DynamicField({
  fieldLabel,
  placeholder,
  fieldType,
  searchText,
  setSearchText,
}) {
  const {isProviderMapPage} = useProviderSearchStore();

  const renderField = (type) => {
    switch (type) {
      case "TEXTFIELD":
        return (
          <ProviderNameSearchField
            placeholder={placeholder}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        );
      case "AUTOCOMPLETE":
        return isProviderMapPage ? <CustomAddressSearchBar /> :<AddressSearchField placeholder={placeholder} />;
      case "PROVIDER_TYPE":
        return <ProviderTypeSearchField placeholder={placeholder} />;
      case "FILTER":
        return <DrawerFilterBtn/>;
      default:
        return null;
    }
  };

  return (
    <div className="flex w-full flex-col gap-1 h-full">
      <Typography style={{ color: HNSColors.neutrals[500] }}>{fieldLabel}</Typography>
      {renderField(fieldType)}
    </div>
  );
}
